import { API_PREFIX, COMPANY_ROUTE, V2_COMPANY_ROUTE } from '@constants'

export const API_CONFIG_URL = `${API_PREFIX}init/`

export const API_DASHBOARD_CHECK_URL = `${COMPANY_ROUTE}status-check/`
// invoice tags
export const API_TAGS_URL = `${COMPANY_ROUTE}tag/`

// tax
export const API_TAX_GROUP_LIST_URL = `${COMPANY_ROUTE}monthly-tax/`
export const API_TAX_GROUP_DETAIL_URL = `${COMPANY_ROUTE}monthly-tax/{monthly_tax_id}/`
export const API_TAX_LIST_URL = `${COMPANY_ROUTE}monthly-tax/{monthly_tax_id}/taxes/`
export const API_TAX_USER_VIEW_URL = `${COMPANY_ROUTE}monthly-tax/{monthly_tax_id}/user-saw/`

// tax codes
export const API_TAX_CODE_LIST_URL = `${COMPANY_ROUTE}taxcode/`

// tagging
export const API_BULK_TAGGING_INIT_URL = `${COMPANY_ROUTE}tag/bulk-query-tags/`
export const API_BULK_TAGGING_UPDATE_URL = `${COMPANY_ROUTE}tag/bulk-update-tags/`

//* accounting
export const API_ASSIGNMENT_NOTE_RECOMMENDATIONS_URL = `${COMPANY_ROUTE}notes`
export const API_LEDGER_NUMBERS_URL = `${COMPANY_ROUTE}ledger-numbers/`

//* new generic event log
export const API_EVENTS_LOG_URL = `${V2_COMPANY_ROUTE}eventlog/{document_type}/{document_id}/`

//* Company consent
export const API_COMPANY_CONSENTS_URL = `${V2_COMPANY_ROUTE}company-consent/`

//* Oauth
export const API_OAUTH_AUTHORIZE_URL = `${API_PREFIX}o/authorize`
